<template>
  <div id="app">
    <Header routeValue="0" ref="header"></Header>
    <content class="content" @click="handleDel()">
      <div class="banner_box">
        <div class="banner_l">
          <span class="title"> Print-on Demand<br/>Service</span>
          <span class="describe">
            We focus on delivering reliable and trustworthy Print-on Demand<br/>
            Dropshipping Fulfillment Services with a suite of powerful features that help grow <br/>
            your businesses.
          </span>
          <div class="explain">
            <img style="margin-right: 16px" src="../assets/checked.png">
            Catalog of 650+ products
          </div>
          <span class="explain">
       <img style="margin-right: 16px" src="../assets/checked.png">
            Easy order management, transparency in production
          </span>
          <span class="explain">
       <img style="margin-right: 16px" src="../assets/checked.png">
            Worldwide Fulfillment Centers
          </span>
          <span class="btn_now" @click="toDesign">
            Design now<div class="icon" style="margin-left: 15px;"><span class="right-arrow"></span></div>
          </span>
          <span class="latest" style="display: flex;">
            Latest orders：
            <a-carousel style="width:400px;line-height: 20px;" autoplay :dots="false" :vertical="true">
              <div v-for="item in orderList">
              <a-icon type="environment" style="font-size: 13px;margin-right: 3px;color: #343183"/>
              <span style="font-size: 15px;color: #222222;font-weight: bold;margin-right: 8px;">{{
                  item.name
                }}, {{ item.country }}</span>
              <span style="color: #485256">{{ item.time }} minutes ago</span>
              </div>
            </a-carousel>
          </span>
        </div>
        <div class="banner_r">
          <div class="swiper_box">
            <img src="../assets/swiper_bg.png">
            <swiper ref="mySwiper" :options="swiperOption" v-if="dataList.length">
              <swiper-slide v-for="(item,index) in dataList" :key="index">
                <img class="img" :src="item.productImg|imgFilter" alt="" @click="toDetailsDes(item)"/>
              </swiper-slide>
            </swiper>
          </div>

        </div>
        <div class="swiper-pagination" slot="pagination" v-if="dataList.length"></div>
      </div>
      <div class="do_box">
        <div class="do_item">
          <span class="title">YOU DO</span>
          <div class="design_box">
            <span>DESIGN</span>
            <span style="font-weight: 500;font-size: 40px">+</span>
            <span>SALE</span>
          </div>
          <div class="img_box">
            <div class="img_item">
              <img class="img" src="../assets/zzsj.jpg">
              <span class="des">Create your unique products and<br/>add them to your store.</span>
            </div>
            <div class="img_item">
              <img class="img" src="../assets/khxd.jpg">
              <span class="des">Create your order and pay,<br/>we'll do the rest.</span>
            </div>
          </div>
        </div>
        <div class="do_item">
          <span class="title">WE DO</span>
          <div class="design_box">
            <span>PRODUCE</span>
            <span style="font-weight: 500;font-size: 40px">+</span>
            <span>FULFILLMENT</span>
          </div>
          <div class="img_box">
            <div class="img_item">
              <img class="img" src="../assets/ffsc.jpg">
              <span class="des">We print, manufacture,<br/>and package your orders.</span>
            </div>
            <div class="img_item">
              <img class="img" src="../assets/bzfh.jpg">
              <span class="des">We ship to anywhere in the world.<br/>Just wait for the delivery.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="products_box">
        <span class="title">Globally Best-Selling Products</span>
        <span class="des">Choose from 650+ products, Simply add your designs</span>
        <div class="tabs_box">
          <a-tabs
            :style="{width: '1074px' ,textAlign: 'center',marginBottom:'30px'}"
            v-model="activeKey"
            :tabBarStyle="tabBarStyle"
            type="card"
            :tab-position="mode"
            @click.stop="changeTab(activeKey)">
            <a-tab-pane
              class="tab_pane"
              v-for="(item,index) in indexList"
              :key="item.id"
              :tab="item.name">
            </a-tab-pane>
          </a-tabs>
          <a-skeleton :loading="isLoading" active :paragraph="{rows: 8, width: 1500}">
            <div class="item_info" v-if="productList.length>0">
              <div class="item_info_l" @click="toDetailsDes(productList[0])">
                <div style="position: relative">
                  <img class="img1" :src="productList[0].productImg|imgFilter">
                  <img class="img2" :src="productList[0].productTemplateImg|imgFilter">
                </div>
                <div class="mask_box">
                  <span class="name">{{ productList[0].productNameEn }}</span>
                  <span class="price">${{ productList[0].lowestPrice }}</span>
                </div>
              </div>
              <div class="item_info_r">
                <div class="item" v-for="item in productList.slice(1, 7)" @click="toDetailsDes(item)">
                  <div class="img_box">
                    <img
                      class="img1" :src="item.productImg|imgFilter">
                    <img
                      class="img2" :src="item.productTemplateImg|imgFilter">
                  </div>
                  <span class="name">{{ item.productNameEn }}</span>
                  <span class="price">From ${{ item.lowestPrice }}</span>
                </div>
              </div>
            </div>
          </a-skeleton>
        </div>
        <div class="more" v-if="productList.length>0" @click="goToProducts">
          View more products
          <img style="margin-left: 15px" src="../assets/icon_0.png">
        </div>
      </div>
      <div class="design_tools_box">
        <span class="title">Design tools</span>
        <span class="des">Let us bring your designs to life</span>
        <div class="item_info" v-if="designList.length>0" style="-webkit-user-select: none;">
          <div class="item_info_l">
            <div class="item" v-for="(item,i) in designList"
                 :class="{ checked: item.checked }"
                 @click="onClickDesign(item,i)">
              <img class="img" :src="item.url|imgFilter">
              <img class="img" :src="item.productTemplateImg|imgFilter" style="display: none;">
            </div>
          </div>
          <div class="item_info_r">
            <div class="origin_img">
              <img :src="designObj.productImg|imgFilter" width="650" height="650">
            </div>
            <div class="mark_img" :style="{width: `${designObj.width}px` }">
              <img :src="designObj.productTemplateImg|imgFilter" width="650" height="650">
            </div>
            <div class="controller"
                 @mousedown="mousedown"
                 @mousemove="mousemove"
                 @mouseup="mouseup"
                 :style="{left: designObj.left + 'px','pointer-events': !isMousemove?'none':'auto'}">
            </div>
          </div>
        </div>
      </div>
      <div class="makes_box">
        <span class="title">What makes Printbelle different?</span>
        <span class="des">We care about all what you need.</span>
        <div class="pagination" slot="pagination"></div>
        <div class="swiper_box">
          <swiper ref="mySwiper1" :options="option">
            <swiper-slide v-for="(item,index) in makesList" :key="index">
              <img class="img" :src="item|imgFilter" alt=""/>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="statistics_box" ref="countToBox">
        <div class="content_info">
          <div class="img"></div>
          <div class="item">
            <count-to class="number" suffix="+" :startVal='0' :endVal='650' :duration='3000' ref="countTo1"></count-to>
            <span class="des">Custom products</span>
          </div>
          <div class="item" style="margin-left: 190px">
            <span style="font-size:30px;font-weight: bold;color: #FFFFFF;">$<count-to class="number" suffix="+"
                                                                                      :startVal='0' :endVal='2000000'
                                                                                      :duration='3000'
                                                                                      ref="countTo2"></count-to></span>
            <span class="des">Invested in printing equipment</span>
          </div>
          <div class="item" style="margin-left: 178px">
            <count-to class="number" suffix="years" :startVal='0' :endVal='10' :duration='3000'
                      ref="countTo3"></count-to>
            <span class="des">Operating time</span>
          </div>
          <div class="item" style="margin-left: 119px">
            <count-to class="number" suffix="+" :startVal='0' :endVal='10000000' :duration='3000'
                      ref="countTo4"></count-to>
            <span class="des">Items fulfilled</span>
          </div>
        </div>
      </div>
      <div class="integration_box">
        <div class="integration_info">
          <div class="title">
            Integration options
          </div>
          <div class="des">
            Fulfillment system integrated with the most popular e-commerce<br/>
            platforms and marketplaces, one-stop order management, goods <br/>
            delivery worldwide.
          </div>
          <span class="learn_more" @click="gotoHelpCenter">
             Learn more<div class="icon" style="margin-left: 15px;"><span class="right-arrow"></span></div>
          </span>
          <div class="img_view">
            <img class="circle_1" src="../assets/circle_1.png">
            <img class="circle_2" src="../assets/circle_2.png">
            <img class="landmark" src="../assets/landmark.png">
          </div>
        </div>

      </div>
      <div class="customers_box">
        <span class="title">Well recognized by customers</span>
        <span class="des">What our customers are saying</span>
        <div class="swiper_box">
          <swiper ref="mySwiper2" :options="option1">
            <swiper-slide v-for="(item,index) in customersList" :key="index">
              <div class="slide_box">
                <div class="top_info">
                  <img class="head" :src="item.head">
                  <div style="display: flex;flex-direction: column">
                    <span class="name">{{ item.name }}</span>
                    <span class="subhead">{{ item.subhead }}</span>
                    <a-rate class="level" :default-value="5" style="color: #F18F02" disabled/>
                  </div>
                </div>
                <div style="width: 47px;height: 5px;background: #343183;margin-top: 51px"></div>
                <div style="width: 286px;height: 1px;background: #EBEBEB"></div>
                <span class="content" v-html="item.content"></span>
              </div>
            </swiper-slide>
          </swiper>
          <div class="button-prev">
            <img src="../assets/prev.png">
          </div>
          <div class="button-next">
            <img src="../assets/next.png">
          </div>
        </div>
      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import {get} from '../api'
import countTo from 'vue-count-to'
import {getRandomInt, shuffle} from '@/utils/utils'

export default {
  name: 'Index',
  components: {
    Header,
    Footer,
    swiper,
    swiperSlide,
    countTo
  },
  data () {
    return {
      mode: 'top',
      isMousedown: false,
      isMousemove: false,
      filterMousemove: false,
      nameList: ['Amsterdam', 'ANGOLA', 'Arras', 'Avon', 'Barcelona', 'Bellevign', 'Benitache', 'Brick', 'Brunswick', 'BUDA', 'Budapest', 'Buggenhou', 'Caguas', 'Caloocan', 'Carteret', 'Cavaria C', 'Cedar Par', 'Charleroi', 'Charlesto', 'Charlotte', 'Chesapeak', 'Christchu', 'Clones', 'Communay', 'Crema', 'DEATSVILL', 'Decatur', 'DeRidder', 'Dorfen', 'Durham', 'Elizabeth', 'Fair Oaks', 'Flen', 'Florence', 'Frei', 'French Ca', 'Gambarogn', 'GARY', 'Geel', 'GLENNVILL', 'Hanau', 'Harxheim', 'Hermosill', 'Hoofddorp', 'Jenks', 'Kiel', 'Kilcock', 'KNOXVILLE', 'Kungsback', 'LAKEWOOD', 'Langenloi', 'Lebanon', 'Libertyvi', 'Littlesto', 'Madrid', 'Mainz', 'Malakoff', 'Mangawhai', 'Marion', 'MARYLAND', 'Maryville', 'Mathod', 'Maussane-', 'Merzkirch', 'MILWAUKEE', 'Monthey', 'MOREAUVIL', 'Muhen', 'newnan', 'NORTH LAS', 'Omaha', 'Orange Ci', 'Oslo', 'OTTAWA', 'Palmetto', 'Pandrup', 'Pasig Cit', 'Pelzer', 'POMONA', 'Porto', 'Rheinberg', 'RICHMOND', 'Roseburg', 'ROY', 'Saint Hen', 'Seattle', 'Sevilla', 'Shipshewa', 'shoreline', 'Silver Sp', 'SPRINGDAL', 'Strvring', 'SUMMERVIL', 'Sundsvall', 'THOMSON', 'Timahoe', 'TROY', 'Wilmingto', 'Wittmann', 'wrrstadt'],
      countryList: ['ES', 'SE', 'PH', 'DE', 'NO', 'IT', 'CH', 'NL', 'IE', 'NZ', 'PT', 'FR', 'DK', 'HU', 'AT', 'MX', 'BE'],
      orderList: [{
        name: '',
        country: '',
        time: ''
      }],
      time: null,
      startLeft: 0,
      title: 0,
      width: 50,
      left: 50,
      activeKey: 0,
      tepValue: 0,
      tabBarStyle: {borderBottom: 'unset'},
      dataList: [],
      makesList: ['/website/different-1.jpg', '/website/different-2.jpg', '/website/different-3.jpg', '/website/different-4.jpg'],
      customersList: [
        {
          head: require('@/assets/head1.png'),
          name: 'Mortimer',
          subhead: 'Shopify Merchant',
          content: '<span>I have always wanted to start my own business</span>\n' +
            '<span>before, but because I have to distribute the goods,</span>\n' +
            '<span>the cost is relatively high, and I am afraid that I will</span>\n' +
            '<span>not be able to find the market and will be forced to</span>\n' +
            '<span>sell goods. Later I learned about this platform,with</span>\n' +
            '<span>zero inventory, minimum order of one piece, and</span>\n' +
            '<span>personalized design, all of which met my needs. I</span>\n' +
            '<span>am very grateful to this platform for allowing me </span>\n' +
            '<span>to embark on the path of self-employment.</span>',
        },
        {
          head: require('@/assets/head2.png'),
          name: 'Leilani',
          subhead: 'Amazon Merchant',
          content: '<span>When I first started cross-border e-commerce, I</span>\n' +
            '<span>was quite confused and didn&rsquo;t know how to</span>\n' +
            '<span>choose products. I accidentally heard about the</span>\n' +
            '<span>printbelle platform from a friend. The complete</span>\n' +
            '<span>supply chain system completely solved my pro-</span>\n' +
            '<span>blem. As long as I put the product in the store and</span>\n' +
            '<span>ship it, I just have to leave it to it, which saves</span>\n' +
            '<span>worry and effort.</span>',
        },
        {
          head: require('@/assets/head3.png'),
          name: 'Blake',
          subhead: 'Etsy seller',
          content: '<span>You can design your own patterns, which greatly</span>\n' +
            '<span>improves customers\' shopping experience. The</span>\n' +
            '<span>quality of the clothes is also very good, soft and</span>\n' +
            '<span>comfortable. Every piece of clothing is carefully</span>\n' +
            '<span>inspected before shipment to see that there are no</span>\n' +
            '<span>excess threads. The printing process is also very</span>\n' +
            '<span>good, and I haven&rsquo;t received any feedback that the</span>\n' +
            '<span>pattern will fade.</span>',
        }
      ],
      indexList: [],
      productList: [],
      designObj: {
        id: 1,
        url: '/website/show-1.jpeg',
        productImg: '/website/show-orgin.jpg',
        productTemplateImg: '/website/show-1-end.jpg',
        checked: true,
        index: 0,
        width: 50,
        left: 325
      },
      designList: [
        {
          id: 1,
          url: '/website/show-1.jpeg',
          productImg: '/website/show-orgin.jpg',
          productTemplateImg: '/website/show-1-end.jpg',
          checked: true
        }, {
          id: 4,
          url: '/website/show-4.webp',
          productImg: '/website/show-orgin.jpg',
          productTemplateImg: '/website/show-4-end.jpg',
          checked: false
        }, {
          id: 7,
          url: '/website/show-7.webp',
          productImg: '/website/show-orgin.jpg',
          productTemplateImg: '/website/show-7-end.jpg',
          checked: false
        }, {
          id: 2,
          url: '/website/show-2.webp',
          productImg: '/website/show-orgin.jpg',
          productTemplateImg: '/website/show-2-end.jpg',
          checked: false
        }, {
          id: 5,
          url: '/website/show-5.webp',
          productImg: '/website/show-orgin.jpg',
          productTemplateImg: '/website/show-5-end.jpg',
          checked: false
        }, {
          id: 8,
          url: '/website/show-8.webp',
          productImg: '/website/show-orgin.jpg',
          productTemplateImg: '/website/show-8-end.jpg',
          checked: false
        }, {
          id: 3,
          url: '/website/show-3.webp',
          productImg: '/website/show-orgin.jpg',
          productTemplateImg: '/website/show-3-end.jpg',
          checked: false
        }, {
          id: 6,
          url: '/website/show-6.webp',
          productImg: '/website/show-orgin.jpg',
          productTemplateImg: '/website/show-6-end.jpg',
          checked: false
        },
        {
          id: 9,
          url: '/website/show-9.webp',
          productImg: '/website/show-orgin.jpg',
          productTemplateImg: '/website/show-9-end.jpg',
          checked: false
        },
      ],
      options: [],
      isLoading: false,
      pageNum: 1,
      pageSize: 20,
      swiperOption: {
        effect: 'flip',
        slidesPerView: 1,
        spaceBetween: 1,
        mousewheel: false,
        autoHeight: true,
        loop: true,
        height: 552,
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
        observer: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          //修改分页器样式
          bulletClass: 'swiper-pagination-bullet',
          //激活样式
          bulletActiveClass: 'my-bullet-active',
        },
      },
      option: {
        slidesPerView: 1,
        spaceBetween: 1,
        mousewheel: false,
        autoHeight: true,
        height: 468,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        observer: true,
        pagination: {
          el: '.pagination',
          clickable: true,
          //修改分页器样式
          bulletClass: 'swiper-pagination-bullet',
          //激活样式
          bulletActiveClass: 'bullet-active',
          renderBullet: function (index, className) {
            let text = ''
            switch (index) {
              case 0:
                text = 'Custom Product'
                break
              case 1:
                text = 'Fast Production'
                break
              case 2:
                text = 'Stable Logistic'
                break
              case 3:
                text = 'Excellent A/S Service'
                break
            }
            return '<span class="' + className + '">' + text + '</span>'
          },
        },
      },
      option1: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: -10,
        loop: true,
        loopFillGroupWithBlank: true,
        height: 530,
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    }
  },
  computed: {
    swiper () {
      return [
        this.$refs.mySwiper.swiper,
        this.$refs.mySwiper1.swiper,
        this.$refs.mySwiper2.swiper,
      ]
    },
  },
  mounted () {
    this.title = window.location.href + 'Index'
    document.body.addEventListener('mousemove', this.mousemove)
    document.body.addEventListener('touchmove', this.mousemove)
    document.body.addEventListener('mouseup', this.mouseup)
    document.body.addEventListener('touchend', this.mouseup)
    this.changeIndex(0)
    const el = this.$refs.countToBox
    const options = {root: null, rootMargin: '0px', threshold: 0.5}
    const observer = new IntersectionObserver(this.handleIntersection, options)
    observer.observe(el)

    this.nameList.forEach(name => {
      this.orderList.push({name: name, country: this.countryList[getRandomInt(0, this.countryList.length - 1)]})
    })
    shuffle(this.orderList)
    let idx = 1
    this.orderList.forEach(order => {
      order.time = idx
      idx += getRandomInt(0, 2)
    })
  },
  beforeDestroy () {
    // 移除事件监听
    document.body.removeEventListener('mousemove', this.mousemove)
    document.body.removeEventListener('touchmove', this.mousemove)
    document.body.removeEventListener('mouseup', this.mouseup)
    document.body.removeEventListener('touchend', this.mouseup)
  },
  created () {
    this.getIndexCarouselList()
    this.getIndexList()
  },
  methods: {
    handleDel () {
      this.$refs.header.delProductValue()
    },
    goToProducts () {
      this.$router.push({path: '/products'})
    },
    gotoHelpCenter () {
      window.open(process.env.VUE_APP_HELP_PC)
    },
    callback (val) {
      console.log(val)
    },
    getIndexCarouselList () {
      get('/index/carousel')
        .then(response => {
          this.dataList = response.data
        })
        .catch(error => {
          console.error(error)
        })

    },
    getIndexList () {
      this.isLoading = true
      get('/index')
        .then(response => {
          this.indexList = response.data
          if (this.indexList.length > 0) {
            this.indexList.forEach(item => {
              item.productDTOList.forEach(onItem => {
                if (!onItem.productTemplateImg) {
                  onItem['productTemplateImg'] = onItem.productImg
                }
              })
            })
            this.productList = this.indexList[0].productDTOList
            this.activeKey = this.indexList[0].id
          }

          this.isLoading = false
        })
        .catch(error => {
          console.error(error)
          this.isLoading = false
        })

    },
    changeTab (value) {
      this.isLoading = true
      let indexObj = this.indexList.find((item) => item.id === value)
      this.productList = indexObj.productDTOList

      this.isLoading = false
    },
    onClickDesign (row, i) {
      this.designList = this.designList.map(item => {
        return {
          ...item,
          checked: row.id === item.id
        }
      })
      this.changeIndex(i, row)
    },

    changeIndex (val, row) {
      this.designObj.width = 0
      this.designObj.left = 0
      this.designObj.index = 0
      document.getElementsByClassName('mark_img')[0].style.transition = 'width 0.5s'
      document.getElementsByClassName('controller')[0].style.transition = 'left 0.5s'
      setTimeout(() => {
        if (row) {
          this.designObj = Object.assign(this.designObj, row)
        }
        document.getElementsByClassName('mark_img')[0].style.transition = 'width 3s'
        document.getElementsByClassName('controller')[0].style.transition = 'left 3s'
        this.designObj.width = 650
        this.designObj.left = 650
        this.isMousemove = true
      }, 1000)
      this.isMousemove = false
    },
    mousedown (e) {
      if (this.isMousedown) {
        return
      }
      document.getElementsByClassName('mark_img')[0].style.transition = 'width 100ms'
      document.getElementsByClassName('controller')[0].style.transition = 'left 100ms'
      this.startLeft = e.clientX - this.designObj.left
      this.isMousedown = true
    },
    mousemove (e) {
      if (!this.isMousedown || this.filterMousemove) {
        return
      }
      let l = e.clientX - this.startLeft
      if (l >= 650) l = 650
      if (l <= 0) l = 0
      this.designObj.width = l
      this.designObj.left = l

      let that = this
      that.filterMousemove = true
      setTimeout(function () {
        that.filterMousemove = false
      }, 40)
    },
    mouseup (e) {
      e.stopPropagation()
      this.isMousedown = false
      this.isMousedown = false
    },
    toDesign () {
      window.open(process.env.VUE_APP_FULFILLMENT + 'product/designer', '_blank')
    },
    handleIntersection (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$refs.countTo1.start()
          this.$refs.countTo2.start()
          this.$refs.countTo3.start()
          this.$refs.countTo4.start()
        }
      })
    },
    toDetailsDes (item) {
      window.open(`/products/${item.seoCustomerAddress}`, '_blank')
    },
  },
}
</script>
<style lang="less">

.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 53px;
  background: #F8FAFC;
}

.content .banner_box {
  width: 100%;
  height: 763px;
  background-image: url(../assets/banner_bg.png);
  background-size: 100% 100%;
  display: flex;
  margin-top: 96px;
}

.content .banner_box .banner_l {
  display: flex;
  flex-direction: column;
  margin-left: 246px;

}

.content .banner_box .banner_l .title {
  font-family: Cerebri Sans;
  font-weight: bold;
  font-size: 65px;
  color: #222222;
  line-height: 61px;
  margin-top: 110px;
}

.content .banner_box .banner_l .describe {
  font-family: Roboto;
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;
  color: #222222;
  margin-top: 18px;
  margin-bottom: 49px;
}

.content .banner_box .banner_l .explain {
  font-family: Roboto;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 16px;
  color: #485256;
  margin-bottom: 8px;

}

.content .banner_box .banner_l .btn_now {
  font-family: Roboto;
  width: 186px;
  height: 55px;
  background: #343183;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  line-height: 30px;
  cursor: pointer;
  color: #FFFFFF;
  font-weight: 400;
  font-size: 20px;
  display: flex;
  margin-bottom: 38px;
  margin-top: 56px;
}

.right-arrow {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-top: 2px solid #F7EAFE;
  border-left: 2px solid #F7EAFE;
  transform: rotate(135deg)
}

.content .banner_box .banner_l .btn_now .icon {
  animation: slide-right 2s infinite;
}

.content .banner_box .banner_l .latest {
  font-family: Roboto;
  font-weight: 400;
  font-size: 15px;
  color: #333333;
}

.content .banner_box .banner_l .explain .icon {
  color: #343183;
  font-size: 24px;
  margin-right: 10px
}

.content .banner_box .banner_r {
  display: flex;
  flex-direction: column;
  margin-top: 43px;
  margin-left: 73px
}

.content .banner_box .banner_r .swiper_box {
  width: 675px;
  height: 675px;
  position: relative;
}

.content .banner_box .banner_r .swiper_box .swiper-container {
  width: 552px;
  height: 552px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.content .banner_box .banner_r .swiper_box .swiper-container .img {
  width: 552px;
  height: 552px;
  border: 1px solid #C2C2C2;
}

.content .banner_box .swiper-pagination {
  position: absolute;
  top: 51%;
  right: 215px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.content .banner_box .my-bullet-active {
  background: #343183;
  border: 2px solid #343183;
}

.content .banner_box .swiper-pagination-bullet {
  width: 18px;
  height: 18px;
  margin-bottom: 16px;
  border-radius: 50%;
  opacity: 1;
  border: 2px solid #343183;
}

.content .do_box {
  height: 614px;
  background: #F8FAFC;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content .do_box .do_item {
  width: 730px;
  height: 459px;
  margin-right: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px 9px 10px 0px rgba(0, 0, 0, 0.05);
  border-radius: 25px;
}

.content .do_box .do_item .title {
  font-family: Cerebri Sans;
  font-weight: bold;
  font-size: 50px;
  line-height: 50px;
  color: #222222;
  margin-top: 36px;
  margin-bottom: 29px;

}

.content .do_box .do_item .design_box {
  width: 688px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-weight: bold;
  font-family: Cerebri Sans;
  font-size: 30px;
  color: #222222;
  z-index: 2;
}

.content .do_box .do_item .design_box span:nth-child(1) {
  width: 312px;
  height: 54px;
  line-height: 54px;
  background: #F8FAFC;
  text-align: center;
  border-radius: 27px;
}

.content .do_box .do_item .design_box span:nth-child(3) {
  width: 312px;
  height: 54px;
  line-height: 54px;
  background: #F8FAFC;
  text-align: center;
  border-radius: 27px;
}

.content .do_box .do_item .img_box {
  width: 100%;
  display: flex;
  justify-content: space-evenly;

}

.content .do_box .do_item .img_box .img_item {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  overflow: hidden;
  transition: all ease 0.3s;
}

.content .do_box .do_item .img_box .img_item:hover {
  display: flex;
  flex-direction: column;

}

.content .do_box .do_item .img_box .img_item:hover .img {
  transition: all ease 0.6s;
  transform: scale(1.1);
}

.content .do_box .do_item .img_box .img_item .img {
  width: 225px;
  height: 225px;
  margin-top: -10px;
  margin-bottom: -20px;
  z-index: 1;
}

.content .do_box .do_item .img_box .img_item .des {
  font-family: Roboto;
  z-index: 2;
  font-weight: 500;
  font-size: 16px;
  color: #485256;
  text-align: center;
  line-height: 24px;
}

.content .products_box {
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content .products_box .more {
  width: 301px;
  font-family: Roboto;
  height: 53px;
  border: 2px solid transparent;
  line-height: 53px;
  font-weight: 500;
  font-size: 18px;
  color: #222222;
  text-align: center;
  cursor: pointer;
  margin-top: 58px;
  margin-bottom: 54px;
  background: #F8FAFC;
  border-radius: 26px;
  transition: all ease 0.6s;
}

.content .products_box .more:hover {
  transition: all ease 0.6s;
  border: 2px solid #343183;
}

.content .products_box .title {
  font-family: Cerebri Sans;
  font-weight: bold;
  font-size: 55px;
  line-height: 55px;
  color: #212121;
  margin-top: 87px;
}

.content .products_box .des {
  font-family: Roboto;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  color: #485256;
  margin-top: 19px;
}

.content .products_box .tabs_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 37px 210px 0 210px;
  background: #FFFFFF;
}

.content .products_box .tabs_box .item_info {
  display: flex;
}

.content .products_box .tabs_box .item_info .item_info_l {
  width: 625px;
  height: 675px;
  background: #FFFFFF;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.07);
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  transition: all ease 0.3s;
}

.content .products_box .tabs_box .item_info .item_info_l .mask_box {
  width: 625px;
  height: 100px;
  background: #343183;
  border-radius: 0 0 10px 10px;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
}

.content .products_box .tabs_box .item_info .item_info_l .img1 {
  width: 625px;
  height: 575px;
  opacity: 1;
  position: absolute;
  top: 0;
  cursor: pointer;
  transition: all ease 0.6s;
}

.content .products_box .tabs_box .item_info .item_info_l .img1:hover {
  opacity: 0;
  transform: scale(1.1);
}

.content .products_box .tabs_box .item_info .item_info_l .img2 {
  width: 625px;
  height: 575px;
  opacity: 0;
  position: absolute;
  top: 0;
  cursor: pointer;
  transition: all ease 0.6s;
}

.content .products_box .tabs_box .item_info .item_info_l .img2:hover {
  opacity: 1;
  transform: scale(1.1);
}


.content .products_box .tabs_box .item_info .item_info_l .mask_box .name {
  width: 560px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 23px;
  margin-top: 9px;
  font-family: Roboto;
  font-size: 30px;
  color: #FFFFFF;
}

.content .products_box .tabs_box .item_info .item_info_l .mask_box .price {
  width: 560px;
  height: 30px;
  margin-left: 23px;
  font-family: Roboto;
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
}

.content .products_box .tabs_box .item_info .item_info_r {
  width: 900px;
  height: 675px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background: #FFFFFF;
}

.content .products_box .tabs_box .item_info .item_info_r .item {
  width: 270px;
  margin-left: 22px;
  margin-bottom: 20px;
  border-radius: 8px;
  display: flex;
  background: #FFFFFF;
  flex-direction: column;
  cursor: pointer;
}


.content .products_box .tabs_box .item_info .item_info_r .item .img_box {
  width: 270px;
  height: 270px;
  position: relative;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  transition: all ease 0.3s;
}


.content .products_box .tabs_box .item_info .item_info_r .item .img_box .img1 {
  width: 100%;
  height: 100%;
  opacity: 1;
  position: absolute;
  top: 0;
  transition: all ease 0.6s;
}

.content .products_box .tabs_box .item_info .item_info_r .item:hover .img_box .img1 {
  opacity: 0;
  transform: scale(1.1);
}

.content .products_box .tabs_box .item_info .item_info_r .item .img_box .img2 {
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  top: 0;
  transition: all ease 0.6s;
}

.content .products_box .tabs_box .item_info .item_info_r .item:hover .img_box .img2 {
  opacity: 1;
  transform: scale(1.1);
}


.content .products_box .tabs_box .item_info .item_info_r .item .name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  margin: 5px 8px 3px 8px;
  font-family: Roboto;
  font-weight: 500;
  font-size: 18px;
  color: #222222;
}

.content .products_box .tabs_box .item_info .item_info_r .item .price {
  font-family: Roboto;
  width: 200px;
  font-weight: 400;
  font-size: 16px;
  margin-left: 8px;
  color: #343183;
}


.content .design_tools_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #F8FAFC;
  padding-bottom: 84px;
  padding-top: 67px
}

.content .design_tools_box .title {
  font-family: Cerebri Sans;
  font-weight: bold;
  font-size: 55px;
  line-height: 55px;
  color: #212121;
}

.content .design_tools_box .des {
  font-family: Roboto;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  margin-top: 20px;
  color: #485256;
}

.content .design_tools_box .item_info {
  display: flex;
  margin-top: 47px;
}


.content .design_tools_box .item_info .item_info_l {
  width: 663px;
  height: 650px;
  margin-right: 13px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.content .design_tools_box .item_info .item_info_l .item {
  width: 200px;
  height: 200px;
  border: 1px solid transparent;
  margin-right: 19px;
  margin-bottom: 25px;
}

.content .design_tools_box .item_info .item_info_l .item.checked {
  border: 1px solid #343183;
}

.content .design_tools_box .item_info .item_info_l .item .img {
  width: 100%;
  height: 100%;
  transition: all ease 0.6s;
}


.content .design_tools_box .item_info .item_info_r {
  width: 650px;
  height: 650px;
  background: #FFFFFF;
  position: relative;
  overflow: hidden;
  transition: all ease 0.3s;
  flex-shrink: 0;

}


.content .design_tools_box .item_info .item_info_r .origin_img {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
}

.content .design_tools_box .item_info .item_info_r .mark_img {
  display: block;
  position: absolute;
  resize: horizontal;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  overflow: hidden;
}

.content .design_tools_box .item_info .item_info_r .controller {
  position: absolute;
  width: 48px;
  height: 100%;
  cursor: pointer;
  transform: translateX(-50%);
  background-image: url(../assets/controller.png);
  background-repeat: no-repeat;
  background-size: 38px 38px;
  background-position: 5px;
}

.content .design_tools_box .item_info .item_info_r .controller::after {
  content: " ";
  width: 2px;
  height: 100%;
  background-color: #343183;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background-repeat: no-repeat;
  background-size: 38px 38px;
  background-position: -19px center;
}


.content .makes_box {
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content .makes_box .title {
  font-family: Roboto;
  font-weight: bold;
  font-size: 55px;
  line-height: 55px;
  margin-top: 49px;
  color: #222222;
}

.content .makes_box .des {
  font-family: Roboto;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  margin-top: 28px;
  color: #485256;
}

.content .makes_box .swiper_box {
  width: 1498px;
  height: 468px;
  position: relative;
  overflow: hidden;
}


.content .makes_box .pagination {
  font-family: Roboto;
  width: 1126px;
  height: 65px;
  background: #F8F8F8;
  border-radius: 33px;
  margin-bottom: 37px;
  margin-top: 40px;
}

.content .makes_box .swiper-pagination-bullet.bullet-active {
  opacity: 1;
  color: #FFFFFF;
  border-radius: 33px;
  background: #343183;
}

.content .makes_box .swiper-pagination-bullet {
  width: 281px;
  height: 65px;
  line-height: 65px;
  font-weight: 600;
  opacity: 1;
  font-size: 26px;
  color: #222222;
  background: #F8F8F8;
  text-align: center;
}


.content .makes_box .swiper_box .swiper-container {
  width: 1498px;
  height: 468px;
  border-radius: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.content .makes_box .swiper_box .swiper-container .img {
  width: 1498px;
  height: 468px;
  cursor: pointer;
  transition: all ease 0.6s;
}

.content .makes_box .swiper_box .swiper-container .img:hover {
  transform: scale(1.1);
}

.content .statistics_box {
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 60px;
}

.content .statistics_box .content_info {
  width: 100%;
  height: 251px;
  display: flex;
  position: relative;
}

.content .statistics_box .content_info .img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background-image: url(../assets/sjtj.png);
  z-index: 10;

}

.content .statistics_box .content_info .item {
  display: flex;
  flex-direction: column;
  margin-left: 300px;
  margin-top: 110px;
  z-index: 11;
}

.content .statistics_box .content_info .item .number {
  font-family: Roboto;
  font-weight: bold;
  font-size: 52px;
  line-height: 52px;
  color: #FFFFFF;
  display: inline-block;
}

.content .statistics_box .content_info .item .des {
  font-family: Roboto;
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  margin-top: 6px;
  color: #FFFFFF;
}


.content .integration_box {
  display: flex;
  height: 664px;
  flex-direction: column;
  background-image: url(../assets/integration.jpg);
  background-size: 100% 100%;

}

.content .integration_box .integration_info {
  position: relative;
  display: flex;
  margin-left: 210px;
  flex-direction: column;

}


.content .integration_box .integration_info .title {
  font-family: Cerebri Sans;
  font-weight: bold;
  font-size: 55px;
  color: #212121;
  margin-top: 230px;
  line-height: 40px;
}

.content .integration_box .integration_info .des {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  line-height: 26px;
  margin-top: 42px;
}

.content .integration_box .integration_info .learn_more {
  font-family: Roboto;
  width: 162px;
  height: 49px;
  background: #343183;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  line-height: 49px;
  cursor: pointer;
  color: #FFFFFF;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  margin-bottom: 38px;
  margin-top: 51px;

  .right-arrow {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-top: 2px solid #F7EAFE;
    border-left: 2px solid #F7EAFE;
    transform: rotate(135deg)
  }

}

.content .integration_box .integration_info .learn_more .icon {
  animation: slide-right 2s infinite;
}

.content .integration_box .integration_info .img_view {
  display: flex;
  position: absolute;
  right: 204px;
}

.content .integration_box .integration_info .img_view .circle_1 {
  top: 268px;
  position: absolute;
  /*animation: slide-left 2s infinite;*/
  z-index: 10;
  right: 88px;
}


.content .integration_box .integration_info .img_view .circle_2 {
  top: 243px;
  position: absolute;
  right: 0;
  z-index: 10;
  /*animation: slide-left 2s infinite;*/
}


.content .integration_box .integration_info .img_view .landmark {
  top: 74px;
  position: absolute;
  right: 50px;
  z-index: 8;
}

.content .customers_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #F8FAFC;

}

.content .customers_box .title {
  font-family: Cerebri Sans;
  font-weight: bold;
  font-size: 55px;
  line-height: 55px;
  color: #222222;
  margin-top: 85px;
}

.content .customers_box .des {
  font-family: Roboto;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  color: #485256;
  margin-top: 21px;
}


.content .customers_box .swiper_box {
  width: 1498px;
  height: 530px;
  margin-top: 28px;
  display: flex;
  position: relative;
}


.content .customers_box .swiper_box .button-prev {
  position: absolute;
  top: 50%;
  opacity: 0.5;
  left: 5px;
  transition: all ease 0.3s;
}

.content .customers_box .swiper_box .button-prev:hover {
  opacity: 1;
}

.content .customers_box .swiper_box .button-next {
  position: absolute;
  top: 50%;
  opacity: 0.5;
  right: 2px;
  transition: all ease 0.3s;
}

.content .customers_box .swiper_box .button-next:hover {
  opacity: 1;
}

.content .customers_box .swiper_box .swiper-container {
  width: 1380px;
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  transform: translate(-50%, -50%);
}

.content .customers_box .swiper_box .swiper-container .slide_box {
  width: 428px;
  height: 530px;
  background: #FFFFFF;
  box-shadow: 0px 10px 10px 0px rgba(7, 7, 7, 0.03);
  border-radius: 10px;
  margin-left: 22px;
  margin-bottom: 20px;
  padding: 57px 32px 35px 35px;
}

.content .customers_box .swiper_box .swiper-container .slide_box .top_info {
  display: flex;
}

.content .customers_box .swiper_box .swiper-container .slide_box .top_info .head {
  width: 92px;
  height: 92px;
  margin-right: 31px;
}

.content .customers_box .swiper_box .swiper-container .slide_box .top_info .name {
  font-family: Cerebri Sans;
  font-weight: bold;
  font-size: 26px;
  line-height: 26px;
  color: #222222;
}

.content .customers_box .swiper_box .swiper-container .slide_box .top_info .subhead {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  margin-top: 14px;
  color: #485256;
}

.content .customers_box .swiper_box .swiper-container .slide_box .top_info .level {
  margin-top: 8px;
}

.content .customers_box .swiper_box .swiper-container .slide_box .content {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  color: #485256;
  background: #FFFFFF;
  line-height: 25px;
  margin-top: 28px;
}

.ant-rate {
  color: #343183;
}

.content {
  .swiper-pagination-bullet {
    background: #FFFFFF;
  }

  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    font-family: Roboto;
    min-width: 102px;
    line-height: 49px;
    font-weight: 500;
    font-size: 19px;
    margin-right: 26px;
    height: 49px;
    background: #FFFFFF;
    border-radius: 23px;
    border: 1px solid #C2C2C2;
    color: #222222;
  }

  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
    height: 49px;
    line-height: 49px;
  }

  :root .ant-tabs-tab-prev-icon-target, :root .ant-tabs-tab-next-icon-target {
    font-size: 26px;
    padding-top: 17px;
  }

  .ant-tabs-tab-prev {
    left: -10px;
  }

  .ant-tabs-tab-next {
    right: -10px;
  }

  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    color: #FFFFFF;
    background: #343183;
    box-shadow: 0px 10px 10px 0px rgba(7, 7, 7, 0.08);
  }
}

@keyframes slide-right {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(50%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slide-left {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(5%);
  }
  100% {
    transform: translateY(0);
  }
}


</style>



// WEBPACK FOOTER //
// src/views/Index.vue